module.exports = __webpack_public_path__ + "public/img/huangguan.c34a8d5f.png";